import axios from 'axios';
import { useState, useEffect } from 'react';
import { Employee } from '../types/employee';

const API_URL = '/api/employees';

export const useGetEmployeeById = (id: string) => {
  const [data, setData] = useState<Employee | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchEmployee = async () => {
      try {
        setIsLoading(true);
        // Mock API call - replace with actual API call
        // const response = await axios.get(`${API_URL}/${id}`);
        // setData(response.data);
        
        // Mock response for now
        setTimeout(() => {
          setData({
            id,
            employeeId: `EMP${id.padStart(3, '0')}`,
            firstName: 'John',
            lastName: 'Doe',
            email: `doctor${id}@example.com`,
            phone: '1234567890',
            employeeType: 'doctor',
            departmentId: 'dept1',
            departmentName: 'Cardiology',
            companyId: 'company1',
            companyName: 'Main Hospital Network',
            dateOfJoining: '2023-01-15',
            status: 'active',
          });
          setIsLoading(false);
        }, 500);
      } catch (err) {
        setError(err as Error);
        setIsLoading(false);
      }
    };

    if (id) {
      fetchEmployee();
    }

    return () => {
      // Cleanup if needed
    };
  }, [id]);

  return { data, isLoading, error };
};

export const updateEmployeeAvailability = async (employeeId: string, availability: any) => {
  try {
    // Mock API call - replace with actual API call
    // const response = await axios.put(`${API_URL}/${employeeId}/availability`, availability);
    // return response.data;
    
    // Mock response for now
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Updated availability:', { employeeId, availability });
        resolve({ success: true });
      }, 500);
    });
  } catch (error) {
    console.error('Error updating availability:', error);
    throw error;
  }
};
